/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener("DOMContentLoaded", function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  new WOW().init();

  let spImgList = [

  ];

  jQuery(".sp-scroll2").slide({
    mainCell: ".nav-imgs",
    autoPlay: true,
    effect: "leftMarquee",
    interTime: 12,
    vis: 1,
    scroll: 1,
  });

  new Swiper(".sp-swiper1", {
    autoplay: true,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
  });

  new Swiper(".sp-swiper7", {
    autoplay: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    pagination: {
      el: ".sp-pagination",
      clickable: true,
    },
  });

  new Swiper(".sp-swiper2", {
    autoplay: true,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    pagination: {
      el: ".sp-pagination",
      clickable: true,
    },
  });

  new Swiper(".sp-swiper3", {
    autoplay: true,
    autoplay: {
      delay: 350000,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    pagination: {
      el: ".sp-pagination",
      clickable: true,
    },
  });

  new Swiper(".sp-swiper-fade", {
    spaceBetween: 10,
    effect: "fade",
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 2000,
    },
    speed: 2000,
  });

  new Swiper(".sp-swiper-fade1", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    loop: true,
    on: {
      slideChange: function (e) {
        e.slides.find(".sp-text").each(function () {
          this.style.animation = "none";
        });
        const spText = e.slides.eq(e.activeIndex).find(".sp-text")[0];
        if (spText) {
          spText.style.animation = "none";

          spText.style.animation = `swiper-up-fade 0.5s ease forwards`;
        }
      },
    },
  });

  new Swiper(".sp-swiper0", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    loop: true,
    pagination: {
      el: ".sp-pagination1",
      clickable: true,
    },
  });

  new Swiper(".sp-swiper-scroll2", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 0,
    },
    slidesPerView: "auto",
    speed: 5000,
    loop: true,
    spaceBetween: 15,
  });

  new Swiper(".sp-swiper-scroll2-pc", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 0,
    },
    slidesPerView: "auto",
    speed: 5000,
    loop: true,
    spaceBetween: 15,
  });

  new Swiper(".sp-swiper1", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 0,
    loop: true,
  });

  $(".sp-mobile .sp-option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");

    // let colorOptions = $("#sp-color .sp-option.active").index();
    let numOptions = $(".sp-mobile .sp-num .sp-option.active").index();
    let typeOptions = $(".sp-mobile .sp-type .sp-option.active").index();

    _index = numOptions + typeOptions * 3;

    $(".product-part.sp-mobile .sp-img-p")
      .eq(_index)
      .addClass("active")
      .siblings()
      .removeClass("active");

    // _swiper.slideToLoop(_index);
  });

  $(".sp-pc .sp-option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");

    // let colorOptions = $("#sp-color .sp-option.active").index();
    let numOptions = $(".sp-pc .sp-num .sp-option.active").index();
    let typeOptions = $(".sp-pc .sp-type .sp-option.active").index();

    _index = numOptions + typeOptions * 3;

    $(".product-part.sp-pc .sp-img-p")
      .eq(_index)
      .addClass("active")
      .siblings()
      .removeClass("active");

    // _swiper.slideToLoop(_index);
  });

  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");
      if (document.body.clientWidth <= 1060) {
        let scale = document.body.clientWidth / 1080;
        $("#root").css("zoom", scale);
      } else {
        const scale = document.body.clientWidth / 1920;
        $("#root").css("zoom", scale);
      }

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");
              if (document.body.clientWidth <= 1060) {
                let scale = document.body.clientWidth / 1080;
                $("#root").css("zoom", scale);
              } else {
                const scale = document.body.clientWidth / 1920;
                $("#root").css("zoom", scale);
              }
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
      config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();

    // preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        let sptop = document.body.clientWidth <= 1080 ? 50 : 94;

        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            sptop * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        });
      });
    });

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log("Android");
    } else if (isIOS) {
      console.log("iOS");
    } else if (isPC) {
      console.log("PC");
    } else {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();

  let sp_price1 = 39.99;
  let sp_price2 = 79.99;
  let prods = window.product
  function calcTotal(price, num) {
    let result = Number(price) * Number(num);
    return result.toFixed(2);
  }

  $('.btn-style').click(function(){
    let num = $(this).siblings('.addGroup').find('input').val()
    num == undefined ? num = 1 : ''
  let id = $(this).closest(".sp-box").find(".opt-group .active").data("id")
  window.location.href = '/cart/' + id + ':' + num
 })

  $('.opt-group .sp-option').click(function () {
    $(this).addClass('active').siblings().removeClass('active')
  })
  $('.sp-group1 .sp-option').click(function () {
    var index = $(this).index()
    $('.sp-pro1 img').eq(index).addClass('active').siblings().removeClass('active')
    $(this).parent().siblings('.sp-price').children('div').eq(index).addClass('active').siblings().removeClass('active')
    $(this).parent().siblings('.sp-tip-box').children('div').eq(index).addClass('active').siblings().removeClass('active')
  })
  $('.sp-group2 .sp-option').click(function () {
    var index = $(this).index()
    $('.sp-pro2 img').eq(index).addClass('active').siblings().removeClass('active')
    $(this).parent().siblings('.sp-price').children('div').eq(index).addClass('active').siblings().removeClass('active')
    $(this).parent().siblings('.sp-tip-box').children('div').eq(index).addClass('active').siblings().removeClass('active')
  })
  $('.sp-group3 .sp-option').click(function () {
    var index = $(this).index()
    $('.sp-pro3 img').eq(index).addClass('active').siblings().removeClass('active')
    $(this).parent().siblings('.sp-price').children('div').eq(index).addClass('active').siblings().removeClass('active')
    $(this).parent().siblings('.sp-tip-box').children('div').eq(index).addClass('active').siblings().removeClass('active')
  })
  $(".sp-mobile .sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    let index = $(this).closest('.sp-box').attr('data-val')
    let sp_price1 = prods[index].price / 100 ;
    let sp_price2 = prods[index].compare_at_price / 100 ;
    let sp_price3 = prods[3].price / 100 ;
    let sp_price4 = prods[3].compare_at_price / 100 ;
    $(this).closest('.sp-box').find("#sp_price1").html(calcTotal(sp_price1, input.value));
    $(this).closest('.sp-box').find("#sp_price2").html(calcTotal(sp_price2, input.value));
    $(this).closest('.sp-box').find("#sp_price3").html(calcTotal(sp_price3, input.value));
    $(this).closest('.sp-box').find("#sp_price4").html(calcTotal(sp_price4, input.value));
  });
  $(".sp-mobile .sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    let index = $(this).closest('.sp-box').attr('data-val')
    let sp_price1 = prods[index].price / 100 ;
    let sp_price2 = prods[index].compare_at_price / 100 ;
    let sp_price3 = prods[3].price / 100 ;
    let sp_price4 = prods[3].compare_at_price / 100 ;
    $(this).closest('.sp-box').find("#sp_price1").html(calcTotal(sp_price1, input.value));
    $(this).closest('.sp-box').find("#sp_price2").html(calcTotal(sp_price2, input.value));
    $(this).closest('.sp-box').find("#sp_price3").html(calcTotal(sp_price3, input.value));
    $(this).closest('.sp-box').find("#sp_price4").html(calcTotal(sp_price4, input.value));
  });

  // PC端套餐价格计算
  var pcPrice1 = 189;
  var pcPrice2 = 209;
  
  $(".sp-pc .sp-box-group .sp-box .addGroup .sp-reduce").click(function () {
    let $box = $(this).closest(".sp-box");
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    let index = $(this).closest('.sp-box').attr('data-val')
    let sp_price1 = prods[index].price / 100 ;
    let sp_price2 = prods[index].compare_at_price / 100 ;
    let sp_price3 = prods[3].price / 100 ;
    let sp_price4 = prods[3].compare_at_price / 100 ;
    $(this).closest('.sp-box').find("#sp_price1").html(calcTotal(sp_price1, input.value));
    $(this).closest('.sp-box').find("#sp_price2").html(calcTotal(sp_price2, input.value));
    $(this).closest('.sp-box').find("#sp_price3").html(calcTotal(sp_price3, input.value));
    $(this).closest('.sp-box').find("#sp_price4").html(calcTotal(sp_price4, input.value));
  });
  
  $(".sp-pc .sp-box-group .sp-box .addGroup .sp-add").click(function () {
    let $box = $(this).closest(".sp-box");
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    let index = $(this).closest('.sp-box').attr('data-val')
    let sp_price1 = prods[index].price / 100 ;
    let sp_price2 = prods[index].compare_at_price / 100 ;
    let sp_price3 = prods[3].price / 100 ;
    let sp_price4 = prods[3].compare_at_price / 100 ;
    $(this).closest('.sp-box').find("#sp_price1").html(calcTotal(sp_price1, input.value));
    $(this).closest('.sp-box').find("#sp_price2").html(calcTotal(sp_price2, input.value));
    $(this).closest('.sp-box').find("#sp_price3").html(calcTotal(sp_price3, input.value));
    $(this).closest('.sp-box').find("#sp_price4").html(calcTotal(sp_price4, input.value));
    
  });

$(function () {
    // 判断是否为移动端
    function isMobile() {
      return document.body.clientWidth <= 1060;
    }
      // 购物车加购动效
    $(".cart-btn").click(function () {
      $(this).children("img").addClass("on");
      if (isMobile()) {
        $(".sp-mobile .sp-cart .num").show();
        $(".sp-mobile .sp-cart").addClass("on");
        setTimeout(function () {
          $(".sp-mobile .sp-cart").removeClass("on");
        }, 500);
      } else {
        $(".sp-pc .sp-header-top .sp-cart .num").show();
        $(".sp-pc .sp-header-top .sp-cart").addClass("on");
        setTimeout(function () {
          $(".sp-pc .sp-header-top .sp-cart").removeClass("on");
        }, 500);
      }
      setTimeout(function () {
        $(".cart-btn").children("img").removeClass("on");
      }, 500);
    });

    let initNum = 0;

    $(".product-part .cart-btn").click(function () {
    //   let spNum = $("#calcNumber")[0].value;
    //   initNum += Number(spNum);

    //   // 更新购物车数量
    //   if (isMobile()) {
    //     $(".sp-mobile .cardNum").each(function () {
    //       $(this).html(initNum);
    //     });
    //   } else {
    //     $(".sp-pc .cardNum").each(function () {
    //       $(this).html(initNum);
    //     });
    //   }
    //   $(".cardNum").removeClass("sp-gray");

    var data = {
        id: $(this).closest(".sp-box").find(".opt-group .active").data("id"),
        quantity: $('#calcNumber').val(),
      };
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
            // $("#cardNum").html(result.item_count);
            $(".cardNum").each(function () {
                $(this).html(result.item_count);
                $(this).removeClass("sp-gray");

            });
          });
        },
        dataType: "json",
      });

      var imgs = $(".sp-pro1 .sp-product-main.active");
      console.log(imgs)

      imgs.each(function () {
        var $img = $(this);
        var flyer = $img[0].cloneNode(true);
        flyer.classList.add("sp_clone");

        $(this).closest(".product-part").append(flyer);
        $(flyer).css({
          width: $img[0].width,
          height: $img[0].height,
          background: "#e7e9ef",
          position: "fixed",
          top: $img[0].offsetTop,
          left: $img.offset().left,
          "z-index": 101,
        });

        let finish, targetTop, targetLeft;
        
        if (isMobile()) {
          // 移动端：飞向底部固定按钮中的购物车
          finish = $(".sp-mobile .sp-sticky-bar-arrow.sp-cart");
          if (finish.length > 0) {
            console.log(finish[0].offsetTop)
            targetTop = $(".sp-mobile.sp-sticky-bar")[0].offsetTop;
            targetLeft = finish[0].offsetLeft + finish.width() - 20;
          } else {
            targetTop = 0;
            targetLeft = 0;
          }
        } else {
          // PC端：飞向header中的购物车
          finish = $(".sp-pc .sp-header-top .sp-cart");
          if (finish.length > 0) {
            targetTop = finish[0].offsetTop + 50;
            targetLeft = finish[0].offsetLeft + finish.width() + 200;
          } else {
            targetTop = 0;
            targetLeft = 0;
          }
        }
        console.log(finish)
        $(flyer).animate(
          {
            top: targetTop,
            left: targetLeft,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          "linear",
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach();
              }
            );
          }
        );
      });
    });
  });
  
  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span");
    const paragraph = gradually.querySelector(".sp-sub-title");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }

  $(".sp-box-group .sp-box").click(function () {
    $(this).addClass("active").siblings().removeClass("active");
  });

  // // 点击按钮
  // $(".sp-video-btn").click(function () {
  //   $(".sp-mask").css("display", "flex");
  // });

  // 菜单
  $(".sp-menu-btn").click(function (e) {
    $(".sp-menu-mask").show();
  });

  $(".sp-menu-mask").click(function (e) {
    // if ($(e.target).closest(".sp-menu-mask li").length > 0) {
    // } else {
    $(".sp-menu-mask").hide();
    // }
  });

  // 初始隐藏按钮
  $(".sp-btn-style2").css("opacity", "0");
  $(".sp-btn-style2").css("pointer-events", "none");

  // 滚动隐藏顶部 - 只对移动端生效
  if (
    $(window).scrollTop() >
    $(".sp-header").height() * $("div#root").css("zoom")
  ) {
    $(".sp-mobile .header-wrap").addClass("sp-fixed");
  } else {
    $(".sp-mobile .header-wrap").removeClass("sp-fixed");
  }

  // 滚动显示底部按钮
  function toggleBottomButton() {
    const scrollTop = $(window).scrollTop();
    const windowHeight = $(window).height();
    const showScrollDistance = windowHeight * 0.5; // 滚动超过首屏高度的50%后显示

    if (scrollTop > showScrollDistance) {
      $(".sp-btn-style2").css("opacity", "1");
      $(".sp-btn-style2").css("pointer-events", "auto");
      $(".sp-btn-style2").css("transition", "opacity 0.3s ease");
    } else {
      $(".sp-btn-style2").css("opacity", "0");
      $(".sp-btn-style2").css("pointer-events", "none");
    }
  }

  // 初始检查
  toggleBottomButton();

  $(window).scroll(function () {
    if (
      $(window).scrollTop() >
      $(".sp-header").height() * $("div#root").css("zoom")
    ) {
      $(".sp-mobile .header-wrap").addClass("sp-fixed");
    } else {
      $(".sp-mobile .header-wrap").removeClass("sp-fixed");
    }

    // 控制底部按钮显示/隐藏
    toggleBottomButton();
  });


  // 问答
  $(".q-row").click(function () {
    $(this).parent().toggleClass("sp-show");
  });

  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName("sp-fade-box");
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll(".sp-ani");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`;
              span.style.animationDelay = `${index * 0.5 + 0.5}s`;
            });

            observerAni.unobserve(gradually2);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observerAni.observe(gradually2);
  }
  // 文本渐出动画
  const graduallyList3 = document.getElementsByClassName("sp-fade-box2");
  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll(".sp-ani2");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`;
              span.style.animationDelay = `${index * 0.3 + 1}s`;
            });

            observerAni.unobserve(gradually3);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observerAni.observe(gradually3);
  }
});

// 手风琴交互逻辑 (新增)
$('.sp-qa1-faq-question').on('click', function() {
    var $currentItem = $(this).parent('.sp-qa1-faq-item'); // 当前点击的父级
    var $answer = $(this).next('.sp-qa1-faq-answer'); // 当前的答案部分
    var $icon = $(this).find('.sp-qa1-faq-icon'); // 当前的图标

    // 如果当前已经是打开的，则关闭它
    if ($currentItem.hasClass('active')) {
        $answer.slideUp();
        $currentItem.removeClass('active');
        $icon.removeClass('fa-minus').addClass('fa-plus');
    } else {
        // 如果当前是关闭的：
        
        // 1. 先关闭所有其他的项 (互斥效果)
        $('.sp-qa1-faq-item').removeClass('active');
        $('.sp-qa1-faq-answer').slideUp();
        $('.sp-qa1-faq-icon').removeClass('fa-minus').addClass('fa-plus');

        // 2. 展开当前项
        $currentItem.addClass('active');
        $answer.slideDown();
        $icon.removeClass('fa-plus').addClass('fa-minus');
    }
});

// 移动端3D动态涟漪模块轮播图和滑块交互
(function() {
  var part3MobileSwiper = document.querySelector('.sp-part3-mobile-swiper');
  if (!part3MobileSwiper) return;

  var swiper = new Swiper('.sp-part3-mobile-swiper', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    },
    allowTouchMove: true
  });

  var slider = document.querySelector('.sp-part3-mobile-slider');
  var thumb = document.querySelector('.sp-part3-mobile-slider-thumb');
  
  if (!slider || !thumb) return;

  var isDragging = false;
  var sliderWidth = 1000;
  var thumbWidth = 36;
  var totalSlides = 4;
  var sectionWidth = sliderWidth / totalSlides;

  function getThumbCenterPosition(index) {
    return (index * sectionWidth) + (sectionWidth / 2) - (thumbWidth / 2);
  }

  function updateThumbPosition(index) {
    var realIndex = index % totalSlides;
    var position = getThumbCenterPosition(realIndex);
    thumb.style.left = position + 'px';
  }

  updateThumbPosition(0);

  swiper.on('slideChange', function() {
    updateThumbPosition(swiper.realIndex);
  });

  thumb.addEventListener('touchstart', function(e) {
    isDragging = true;
    swiper.autoplay.stop();
    e.preventDefault();
  });

  thumb.addEventListener('mousedown', function(e) {
    isDragging = true;
    swiper.autoplay.stop();
    e.preventDefault();
  });

  document.addEventListener('touchmove', function(e) {
    if (!isDragging) return;
    
    var touch = e.touches[0];
    var rect = slider.getBoundingClientRect();
    var x = touch.clientX - rect.left - thumbWidth / 2;
    var maxLeft = sliderWidth - thumbWidth;
    
    if (x < 0) x = 0;
    if (x > maxLeft) x = maxLeft;
    
    thumb.style.left = x + 'px';
    
    var slideIndex = Math.floor((x + thumbWidth / 2) / sectionWidth);
    if (slideIndex >= totalSlides) slideIndex = totalSlides - 1;
    swiper.slideTo(slideIndex);
  });

  document.addEventListener('mousemove', function(e) {
    if (!isDragging) return;
    
    var rect = slider.getBoundingClientRect();
    var x = e.clientX - rect.left - thumbWidth / 2;
    var maxLeft = sliderWidth - thumbWidth;
    
    if (x < 0) x = 0;
    if (x > maxLeft) x = maxLeft;
    
    thumb.style.left = x + 'px';
    
    var slideIndex = Math.floor((x + thumbWidth / 2) / sectionWidth);
    if (slideIndex >= totalSlides) slideIndex = totalSlides - 1;
    swiper.slideTo(slideIndex);
  });

  document.addEventListener('touchend', function() {
    if (!isDragging) return;
    isDragging = false;
    
    var currentLeft = parseFloat(thumb.style.left) || 0;
    var slideIndex = Math.floor((currentLeft + thumbWidth / 2) / sectionWidth);
    if (slideIndex >= totalSlides) slideIndex = totalSlides - 1;
    
    updateThumbPosition(slideIndex);
    swiper.slideTo(slideIndex);
    swiper.autoplay.start();
  });

  document.addEventListener('mouseup', function() {
    if (!isDragging) return;
    isDragging = false;
    
    var currentLeft = parseFloat(thumb.style.left) || 0;
    var slideIndex = Math.floor((currentLeft + thumbWidth / 2) / sectionWidth);
    if (slideIndex >= totalSlides) slideIndex = totalSlides - 1;
    
    updateThumbPosition(slideIndex);
    swiper.slideTo(slideIndex);
    swiper.autoplay.start();
  });

  slider.addEventListener('click', function(e) {
    var rect = slider.getBoundingClientRect();
    var x = e.clientX - rect.left;
    
    var slideIndex = Math.floor(x / sectionWidth);
    if (slideIndex >= totalSlides) slideIndex = totalSlides - 1;
    
    updateThumbPosition(slideIndex);
    swiper.slideTo(slideIndex);
  });
})();

// PC端3D动态涟漪模块轮播图和滑块交互
(function() {
  var part3PcSwiper = document.querySelector('.sp-part3-pc-swiper');
  if (!part3PcSwiper) return;

  var swiper = new Swiper('.sp-part3-pc-swiper', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    },
    allowTouchMove: true
  });

  var slider = document.querySelector('.sp-part3-pc-slider');
  var thumb = document.querySelector('.sp-part3-pc-slider-thumb');
  
  if (!slider || !thumb) return;

  var isDragging = false;
  var sliderWidth = 698;
  var thumbWidth = 25;
  var totalSlides = 4;
  var sectionWidth = sliderWidth / totalSlides;

  function getThumbCenterPosition(index) {
    return (index * sectionWidth) + (sectionWidth / 2) - (thumbWidth / 2);
  }

  function updateThumbPosition(index) {
    var realIndex = index % totalSlides;
    var position = getThumbCenterPosition(realIndex);
    thumb.style.left = position + 'px';
  }

  updateThumbPosition(0);

  swiper.on('slideChange', function() {
    updateThumbPosition(swiper.realIndex);
  });

  thumb.addEventListener('mousedown', function(e) {
    isDragging = true;
    swiper.autoplay.stop();
    e.preventDefault();
  });

  document.addEventListener('mousemove', function(e) {
    if (!isDragging) return;
    
    var rect = slider.getBoundingClientRect();
    var x = e.clientX - rect.left - thumbWidth / 2;
    var maxLeft = sliderWidth - thumbWidth;
    
    if (x < 0) x = 0;
    if (x > maxLeft) x = maxLeft;
    
    thumb.style.left = x + 'px';
    
    var slideIndex = Math.floor((x + thumbWidth / 2) / sectionWidth);
    if (slideIndex >= totalSlides) slideIndex = totalSlides - 1;
    swiper.slideTo(slideIndex);
  });

  document.addEventListener('mouseup', function() {
    if (!isDragging) return;
    isDragging = false;
    
    var currentLeft = parseFloat(thumb.style.left) || 0;
    var slideIndex = Math.floor((currentLeft + thumbWidth / 2) / sectionWidth);
    if (slideIndex >= totalSlides) slideIndex = totalSlides - 1;
    
    updateThumbPosition(slideIndex);
    swiper.slideTo(slideIndex);
    swiper.autoplay.start();
  });

  slider.addEventListener('click', function(e) {
    var rect = slider.getBoundingClientRect();
    var x = e.clientX - rect.left;
    
    var slideIndex = Math.floor(x / sectionWidth);
    if (slideIndex >= totalSlides) slideIndex = totalSlides - 1;
    
    updateThumbPosition(slideIndex);
    swiper.slideTo(slideIndex);
  });
})();

// PC端Details That Delight模块轮播图
(function() {
  var part6PcSwiper = document.querySelector('.sp-part6-pc-swiper');
  if (!part6PcSwiper) return;

  var swiper = new Swiper('.sp-part6-pc-swiper', {
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: 50,
    loop: true,
    allowTouchMove: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    }
  });

  var arrowLeft = document.querySelector('.sp-part6-pc-arrow-left');
  var arrowRight = document.querySelector('.sp-part6-pc-arrow-right');

  if (arrowLeft) {
    arrowLeft.addEventListener('click', function() {
      swiper.slidePrev();
    });
  }

  if (arrowRight) {
    arrowRight.addEventListener('click', function() {
      swiper.slideNext();
    });
  }
})();

// 移动端Details That Delight模块轮播图
(function() {
  var part6MobileSwiper = document.querySelector('.sp-part6-mobile-swiper');
  if (!part6MobileSwiper) return;

  var swiper = new Swiper('.sp-part6-mobile-swiper', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    allowTouchMove: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    }
  });

  var arrowLeft = document.querySelector('.sp-part6-mobile-arrow-left');
  var arrowRight = document.querySelector('.sp-part6-mobile-arrow-right');
  var dots = document.querySelectorAll('.sp-part6-mobile-dot');

  function updatePagination(index) {
    var realIndex = index % 3;
    dots.forEach(function(dot, i) {
      if (i === realIndex) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });
  }

  swiper.on('slideChange', function() {
    updatePagination(swiper.realIndex);
  });

  if (arrowLeft) {
    arrowLeft.addEventListener('click', function() {
      swiper.slidePrev();
    });
  }

  if (arrowRight) {
    arrowRight.addEventListener('click', function() {
      swiper.slideNext();
    });
  }

  dots.forEach(function(dot, i) {
    dot.addEventListener('click', function() {
      swiper.slideTo(i);
    });
  });
})();

// PC端Compact Design模块轮播图（自动滚动）
(function() {
  var part7Carousel = document.querySelector('#sp-part7-carousel .swiper');
  if (!part7Carousel) return;

  var swiper = new Swiper('#sp-part7-carousel .swiper', {
    grabCursor: true,
    centeredSlides: false,
    slidesPerView: 'auto',
    spaceBetween: 20,
    loop: true,
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
      reverseDirection: false,
    },
    freeMode: {
      enabled: true,
      momentum: false,
    },
    speed: 5000,
    on: {
      touchEnd: function() {
        var s = this;
        setTimeout(function() {
          s.autoplay.stop();
          s.autoplay.start();
        }, 50);
      },
      slideChangeTransitionEnd: function() {
        var s = this;
        setTimeout(function() {
          if (!s.autoplay.running) {
            s.autoplay.stop();
            s.autoplay.start();
          }
        }, 50);
      }
    }
  });

  setInterval(function() {
    if (swiper && !swiper.autoplay.running) {
      swiper.autoplay.start();
    }
  }, 1000);
})();

// 移动端Compact Design模块轮播图（自动滚动）
(function() {
  var part7MobileCarousel = document.querySelector('#sp-part7-mobile-carousel .swiper');
  if (!part7MobileCarousel) return;

  var swiper = new Swiper('#sp-part7-mobile-carousel .swiper', {
    grabCursor: true,
    centeredSlides: false,
    slidesPerView: 'auto',
    spaceBetween: 20,
    loop: true,
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
      reverseDirection: false,
    },
    freeMode: {
      enabled: true,
      momentum: false,
    },
    speed: 5000,
    on: {
      touchEnd: function() {
        var s = this;
        setTimeout(function() {
          s.autoplay.stop();
          s.autoplay.start();
        }, 50);
      },
      slideChangeTransitionEnd: function() {
        var s = this;
        setTimeout(function() {
          if (!s.autoplay.running) {
            s.autoplay.stop();
            s.autoplay.start();
          }
        }, 50);
      }
    }
  });

  setInterval(function() {
    if (swiper && !swiper.autoplay.running) {
      swiper.autoplay.start();
    }
  }, 1000);
})();
